<template>
  <Modal ref="modal">

    <div class="row">
      <div class="form-group col-6">
        <input class="form-control" v-model="period.year" placeholder="Rok" />
      </div>
      <div class="form-group col-6">
        <input class="form-control" v-model="period.month" placeholder="Miesiąc" />
      </div>
    </div>

    <div>
      <button class="btn btn-dark" v-on:click="$refs.modal.ok()">OK</button>
      <button class="btn btn-dark" v-on:click="$refs.modal.cancel()">Anuluj</button>
    </div>

  </Modal>
</template>

<script>
export default {
  data() {
    return {
      period: {}
    };
  },
  methods: {
    show(period) {
      this.period = this.$tools.copyOf(period);

      return this.$refs.modal.open().then(() => {
        this.period.year = parseInt(this.period.year);
        this.period.month = parseInt(this.period.month);
        return this.period;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>